import { lazy } from "react";

export {
  REQUESTS_ABSENCE_CREATE_PATH,
  REQUESTS_ABSENCE_EDIT_PATH,
} from "./requests-absence-form-path";

export const RequestAbsenceForm = lazy(() => import("./requests-absence-form"));
export { ToRequestsAbsenceForm } from "./to-requests-absence-form";
